













































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class OnboardingDialog extends Vue {
	slideNumber: number = 0;

	imageUrls: string[] = [
		"/img/onboarding/success.svg",
		"/img/onboarding/world_wide_web.svg",
		"/img/onboarding/notification.svg",
	];
}
